import React from 'react';
import LockedIcon from './images/locked-icon';
import { Form, InputGroup, Text } from '../../components';
import { TextArea } from '@kmx/legos-react-text-area';
import { Button } from '@kmx/legos-react-button';
import AppForm from '../constants/app-forms';
import RequestType from '../constants/request-types';

class MessageForm extends React.Component {
  constructor(props) {
    super(props);
    this.formType = AppForm.Message;
    this.state = {
      stateError: false,
      formFields: {
        message: '',        
      },
      invalidFields: [],
    };

    this.timer = null;
    this.formRef = React.createRef();
    this.onValidateHandler = this.onValidateHandler.bind(this);
    this.updateMessageInputField = this.updateMessageInputField.bind(this);    
    this.scrollTop = this.scrollTop.bind(this);
  }

  // eslint-disable-next-line
  componentDidMount() { }
  // eslint-disable-next-line
  componentWillUnmount() { }

  scrollTop() {
    window && window.scrollTo(0, 0);
  }

  onValidateHandler(invalidFields) {
    this.setState({ invalidFields });
  }

  updateMessageInputField(e) {
    this.setState({
      formFields: {
        ...this.state.formFields,
        message: e.target.value,
      },
    });
  }

  
 
  render() {
    const { invalidFields } = this.state;
    const { formFields } = this.state;
    const { message } = formFields;
    const submitDisabled = invalidFields.length > 0 || (message + '').trim().length < 3;

    return (
      <div className='message-form'>
        {(this.props.requestType === RequestType.Correct || this.props.requestType == RequestType.CorrectBehalf) ? <>
        <Text.Display3 className='m-b-m'>Tell us about what information you would like us to correct.</Text.Display3>
        <Text.Body1 className='m-b-m fs-mask'>
          <p>You can enter each item, line by line, or just describe what is inaccurate.</p>
          <p>Example:<br />
					<span className="helper-text">My last name is spelled wrong. It's in your system as Smyth, but it should be Smith.</span>
					<br />
					<span className="helper-text">Also, you have "jr." as my suffix. I'm not a junior. I don't have any suffix.</span>
          </p>
        </Text.Body1>
        </> : null}

        {(this.props.requestType === RequestType.Appeal || this.props.requestType === RequestType.AppealBehalf) ? <>
            <Text.Display3 className='m-b-m'>Tell us what you are appealing.</Text.Display3>
            <Text.Body1 className='m-b-m'>
              <p>Please explain what you would like us to review and why.</p>
            </Text.Body1>
            </> : null}


        <Form onValidate={this.onValidateHandler} ref={this.formRef}>
          <div>
            <InputGroup>
               <TextArea
                onChange={this.updateMessageInputField}
                className='m-t-0 m-b-0 fs-mask'
                errorText='Enter message to CarMax'
                label='Message to CarMax'
                name='messageInput'
                required
                value={message}
              />             
            </InputGroup>

            <Button
              className='kmx-button--full m-t-l'
              disabled={submitDisabled}
              full={true}
              level='primary'
              type='button'
              onClick={() => this.props.handleNextStep(this.formType, this.state.formFields)}>
              Continue
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default MessageForm;
